<section>
  <div class="container-fluid bg-lightgrey py-5">
    <h1 class="h3 text-center">Open data</h1>
  </div>
  <div class="container-narrow py-5">
    <p>
      I dati di Centri d'Italia sono disponibili per il download in formato csv. I dati sono aggiornati a dicembre 2023
      e contengono le informazioni
      per gli anni 2018, 2019, 2020, 2021, 2022 e 2023. La licenza per il loro utilizzo è la <a
      href="https://creativecommons.org/licenses/by/4.0/deed.it" target="_blank"
      rel="noopener">CC-BY 4.0</a>.
    </p>
    <p>
      Sono rilasciati tre file csv: uno riguarda Cas, Cpa e Hotspot, gli altri due riguardano i progetti e le strutture
      SAI (Sistema accoglienza e
      integrazione). &Egrave; disponibile anche un file di metadati con la spiegazione dei campi contenuti nei csv e il
      loro formato.
    </p>
    <ul>
      <li><a href="https://migrantidb.s3.eu-central-1.amazonaws.com/opendata/centri_cas_cpa_hotspot_v2025.csv" download="centri_cas_cpa_hotspot_v2025.csv">Cas, Cpa
        e Hotspot</a></li>
      <li><a href="https://migrantidb.s3.eu-central-1.amazonaws.com/opendata/sai_progetti_v2025.csv" download="sai_progetti_v2025.csv">Progetti SAI</a>
      </li>
      <li><a href="https://migrantidb.s3.eu-central-1.amazonaws.com/opendata/sai_struttura_v2025.csv" download="sai_struttura_v2025.csv">Strutture SAI</a>
      </li>
      <li><a href="https://migrantidb.s3.eu-central-1.amazonaws.com/opendata/metadati_centri_v2025.xlsx" download="metadati_centri_v2025.xlsx">Metadati</a>
      </li>
    </ul>
    <p>
      Infine è fornita una selezione di dati della Banca Dati Nazionale dei Contratti Pubblici relativi ai bandi per la
      gestione di centri di accoglienza governativi.

    </p>
    <ul>
      <li><a href="https://migrantidb.s3.eu-central-1.amazonaws.com/opendata/bandi_ANAC_accoglienza_v2025.csv">Bandi ANAC</a>
      </li>

    </ul>
  </div>
</section>
